import { clearAccessToken, saveAccessToken } from "../../../api/apiClient";
import { clearQueueToken } from "../../../helpers/queueToken";
import { ILoginRespone } from "../../../model/respone/auth/ILoginRespone";
import { eAuthActionTypeDefine } from "../../action-types/auth/IAuthActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const authActions = {
    ...generateActions(eAuthActionTypeDefine, "AUTH"),
    ...generateActionForKey(eAuthActionTypeDefine, "AUTH", "LOGIN_SUCCESS", (payload: ILoginRespone) => {
        saveAccessToken(payload.access_token);
        localStorage.setItem("user_info", JSON.stringify(payload.user));
        localStorage.setItem("expires_at", payload.expires_at);
    }),
    ...generateActionForKey(eAuthActionTypeDefine, "AUTH", "RESTORE_SESSION", (payload: ILoginRespone) => {
        saveAccessToken(payload.access_token);
        localStorage.setItem("user_info", JSON.stringify(payload.user));
        localStorage.setItem("expires_at", payload.expires_at);
    }),
    ...generateActionForKey(eAuthActionTypeDefine, "AUTH", "LOGOUT", () => {
        clearAccessToken();
        // Cũng clear queue token để không bị stale sau re-login. Middleware backend vẫn check
        // token theo SV nên không phải security bug, nhưng tránh confusion với UI/dev.
        clearQueueToken();
        localStorage.removeItem("user_info");
        localStorage.removeItem("expires_at");
    }),
};
